import { render, staticRenderFns } from "./OrderablePreviewProducts.vue?vue&type=template&id=28f98212&"
import script from "./OrderablePreviewProducts.vue?vue&type=script&lang=ts&"
export * from "./OrderablePreviewProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports